// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fmP2-","rootNoMargin":"styles_rootNoMargin__3gmYi"};